import { render } from "./FooterArea.vue?vue&type=template&id=8b15c0e2"
import script from "./FooterArea.vue?vue&type=script&lang=js"
export * from "./FooterArea.vue?vue&type=script&lang=js"

import "./FooterArea.vue?vue&type=style&index=0&id=8b15c0e2&lang=scss"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__